import { motion } from "framer-motion";
import { ArrowUpRight, BellRing } from "lucide-react";
import { Chapter, Reveal } from "@/components/Chapter";
import { useContent } from "@/content";

export const Divisions = ({ onNavigate }) => {
  const { DIVISIONS } = useContent();
  return (
  <section id="divisions" className="py-24 md:py-32 border-y border-slate-200 bg-white" data-testid="divisions-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-8">
      <Chapter
        id="04"
        name="Our divisions"
        title="One brand. Focused divisions, each built to lead its craft."
        sub="Desantrix Web is live today. Three more divisions are being built — each launching only when it can deliver at the standard we set."
      />

      <div className="grid sm:grid-cols-2 gap-6" data-testid="divisions-grid">
        {DIVISIONS.map((d, i) => (
          <Reveal key={d.name} delay={i * 0.08} className="h-full">
            <motion.div
              whileHover={d.active ? { y: -8 } : { y: -3 }}
              transition={{ type: "spring", stiffness: 260, damping: 20 }}
              className={`relative h-full rounded-2xl border p-8 transition-colors duration-500 ${
                d.active
                  ? "border-amber-400/60 bg-gradient-to-br from-amber-50 to-white shadow-[0_24px_60px_-24px_rgba(255,159,28,0.35)]"
                  : "border-slate-200 bg-slate-50/60 hover:border-slate-300"
              }`}
              data-testid={`division-${d.name.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <div className="flex items-start justify-between gap-4 mb-5">
                <h3 className={`text-xl sm:text-2xl font-semibold ${d.active ? "text-[#0B1528]" : "text-slate-400"}`}>{d.name}</h3>
                <span
                  className={`shrink-0 rounded-full px-3 py-1 font-mono text-[10px] tracking-[0.2em] uppercase border ${
                    d.active
                      ? "bg-emerald-100 text-emerald-700 border-emerald-300"
                      : "bg-slate-200/70 text-slate-500 border-slate-300"
                  }`}
                >
                  {d.status}
                </span>
              </div>
              <p className={`text-sm leading-relaxed ${d.active ? "text-slate-600" : "text-slate-400"}`}>{d.desc}</p>
              {d.active && (
                <button
                  onClick={() => onNavigate("contact")}
                  data-testid="division-web-cta"
                  className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-amber-600 hover:text-amber-700 active:scale-95 transition-all"
                >
                  Start a website project
                  <ArrowUpRight className="h-4 w-4" />
                </button>
              )}
              {d.notify && (
                <button
                  onClick={() => onNavigate("academy")}
                  data-testid="division-academy-notify-cta"
                  className="mt-6 inline-flex items-center gap-2 rounded-full border border-slate-300 bg-white px-4 py-2 text-xs font-semibold text-slate-600 hover:border-amber-400 hover:text-amber-600 active:scale-95 transition-all"
                >
                  <BellRing className="h-3.5 w-3.5" />
                  Notify me at launch
                </button>
              )}
            </motion.div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
};
